import {Component} from '@angular/core';


@Component({
    selector: 'tfl-bo-badge',
    template: `<ng-content></ng-content>`
})
export class BadgeComponent {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/badge/badge.component.ts